const defaults = require('./defaults');

const { elastic } = defaults;

module.exports = {
  ...defaults,
  cacheControl: 'max-age=120',
  onlineClientUrlRoot: 'https://development.ls-www.localsearch.cloud',
  urlRoot: 'https://development.ls-www.localsearch.cloud',
  recaptchaRoot:
    'https://u67big8d6b.execute-api.ap-southeast-2.amazonaws.com/development',
  serviceApiRoot: 'https://development.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://development.services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://images.development.ls-www.localsearch.cloud',
  logger: {
    ...defaults.logger,
    console: {
      level: 'error',
    },
  },
  bpm: {
    baseUrl: 'https://forbusiness.development.localsearch.cloud',
  },
  token: {
    ...defaults.token,
    cookie: { domain: '.localsearch.cloud' },
  },
  auth: {
    ...defaults.auth,
    redirectUri: 'https://development.ls-www.localsearch.cloud/login-loader',
    returnTo: 'https://development.ls-www.localsearch.cloud',
  },
  elastic: {
    ...elastic,
    node: 'https://es8.elasticsearch-dev.localsearch.cloud',
  },
  deploy: {
    domain: 'development.ls-www.localsearch.cloud',
    aliases: 'development.ls-www.localsearch.cloud',
    certificateArn:
      'arn:aws:acm:us-east-1:789417954668:certificate/bae9ed63-b36d-478f-8684-1d8066162fc0',
    legacyBucket: 'wwwresource.localsearch.com.au.s3.amazonaws.com',
    webAcl:
      'arn:aws:wafv2:us-east-1:789417954668:global/webacl/ls-web-react-development/dd0deeb0-39f8-46ea-9a5b-47f12c4ee637',
    logBucket: 'ls-web-react-logs-dev',
    vpcSubnetIds: ['subnet-46f3a921', 'subnet-b49d4bec', 'subnet-5b93c412'],
    vpcSecurityGroupIds: ['sg-42d09625'],
  },
};
